import { fromColumn, type Money } from '@evogard/domain';

/** O valor do fio (`"1500.00"`) em centavos. */
export const money = (wire: string): Money => fromColumn(wire) as Money;

/** "R$ 12,4 mil", "−R$ 980" — o valor curto, para caber ao lado da barra e no miolo da rosca. */
export function compact(value: Money): string {
  const reais = value / 100;
  const sign = reais < 0 ? '−' : '';
  const abs = Math.abs(reais);
  if (abs >= 1_000_000)
    return `${sign}R$ ${(abs / 1_000_000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} mi`;
  if (abs >= 1_000)
    return `${sign}R$ ${(abs / 1_000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} mil`;
  return `${sign}R$ ${Math.round(abs).toLocaleString('pt-BR')}`;
}
